module.exports = __webpack_public_path__ + "img/icon-film.53e66b6e.svg";